import React, { Component } from 'react';
import { Link } from 'react-router-dom';

export default class Refund extends Component {
  render() {
    return (
      <div>
        {/* Page Title */}
        <section className="page-title bg-1">
          <div className="overlay"></div>
          <div className="container">
            <div className="row">
              <div className="col-md-12">
                <div className="block text-center">
                  <span className="text-white">Refund Policy</span>
                  <h1 className="text-capitalize mb-5 text-lg">Refund Policy</h1>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Refund Content */}
        <section className="section refund-section">
          <div className="container">
            <div className="row justify-content-center">
              <div className="col-lg-8 text-center">
                <hr /><hr/>
                <p>Thank you for choosing Varenya Matrimonial. Please note that <strong>no refunds</strong> will be issued once the membership registration is completed.</p>
                <p>We encourage you to carefully review all membership details and terms before completing your registration. For any questions or clarifications, please contact our support team before making a purchase.</p>
                <hr /><hr/>
                {/* Call to Action */}
                <section className="section text-center py-3">
                  <div className="container">
                    <Link to="/contact" className="btn btn-main btn-round-full mx-2">Register Now</Link>
                    <Link to="/pricing" className="btn btn-main btn-round-full mx-2" style={{ background: "black" }}>View Pricing</Link>
                  </div>
                </section>
              </div>
            </div>
          </div>
        </section>
      </div>
    );
  }
}
